import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    title: 'Locales',
    children: [
      {
        path: 'locales',
        loadChildren: () =>
          import('./features/locales-management/locales.module').then(
            (m) => m.LocalesModule
          ),
        title: 'Locales Management',
      },
      { path: '**', redirectTo: 'locales' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
